<div class="transfer-backdrop"
     (click)="cancel()">
  <section class="transfer-dialog"
           (click)="$event.stopPropagation()">
    <header class="transfer-header">
      <div class="transfer-heading">
        <span class="transfer-kicker">{{ 'message.transferDialog.kicker' | translate }}</span>
        <h2>{{ 'message.transferDialog.title' | translate }}</h2>
      </div>
      <button type="button"
              class="transfer-close"
              [attr.aria-label]="'message.context.cancel' | translate"
              (click)="cancel()">
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <div class="transfer-body">
      <!-- Assuré -->
      <div class="transfer-field">
        <label class="transfer-field-label">
          <mat-icon>person</mat-icon>
          <span>{{ 'message.context.person' | translate }}</span>
        </label>
        <mat-form-field class="transfer-person" appearance="outline" subscriptSizing="dynamic">
          <input matInput
                 [ngModel]="personSearchTerm()"
                 (ngModelChange)="onPersonSearchChange($event)"
                 [matAutocomplete]="autoPerson"
                 [placeholder]="'message.context.searchPerson' | translate">
          @if (personsResource.isLoading()) {
          <mat-spinner matSuffix [diameter]="18"></mat-spinner>
          } @else if (personSearchTerm()) {
          <button type="button"
                  matSuffix
                  class="field-clear"
                  [attr.aria-label]="'common.clear' | translate"
                  (click)="clearPerson()">
            <mat-icon>close</mat-icon>
          </button>
          }
          <mat-autocomplete #autoPerson="matAutocomplete"
                            [displayWith]="displayPerson"
                            (optionSelected)="onPersonSelected($event.option.value)">
            @for (option of personsOptions(); track option.id) {
            <mat-option [value]="option">
              <div class="person-option-row">
                <span class="person-name">{{ getPersonPrimaryLabel(option) }}</span>
                <div class="person-meta">
                  @if (option.birthDate) {
                  <span>{{ option.birthDate | date:'dd.MM.yyyy' }}</span>
                  }
                  @if (getPersonLocality(option)) {
                  <span class="meta-separator">-</span>
                  <span>{{ getPersonLocality(option) }}</span>
                  }
                </div>
              </div>
            </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <!-- Bâtiment -->
      <div class="transfer-field">
        <label class="transfer-field-label">
          <mat-icon>home</mat-icon>
          <span>{{ 'message.context.building' | translate }}</span>
        </label>
        <ecab-select [options]="buildingOptions()"
                     [ngModel]="selectedBuildingId()"
                     [ngModelOptions]="{ standalone: true }"
                     [placeholder]="'message.context.selectBuilding' | translate"
                     (selectionChange)="onBuildingChange($any($event))"></ecab-select>
      </div>

      <!-- Dossier -->
      <div class="transfer-field">
        <label class="transfer-field-label">
          <mat-icon>folder</mat-icon>
          <span>{{ 'message.context.case' | translate }}</span>
        </label>
        <ecab-select [options]="caseOptions()"
                     [ngModel]="selectedCaseId()"
                     [ngModelOptions]="{ standalone: true }"
                     [placeholder]="'message.context.selectCase' | translate"
                     (selectionChange)="onCaseChange($any($event))"></ecab-select>
      </div>

      <!-- Catégorie -->
      <div class="transfer-field">
        <label class="transfer-field-label">
          <mat-icon>category</mat-icon>
          <span>{{ 'message.context.questionType' | translate }}</span>
        </label>
        <ecab-select [options]="questionTypeOptions()"
                     [ngModel]="questionType()"
                     [ngModelOptions]="{ standalone: true }"
                     [placeholder]="'message.context.selectQuestionType' | translate"
                     (selectionChange)="onQuestionTypeChange($any($event))"></ecab-select>
      </div>

      <!-- Sujet -->
      <div class="transfer-field">
        <label class="transfer-field-label">
          <mat-icon>subject</mat-icon>
          <span>{{ 'message.context.subject' | translate }}</span>
        </label>
        <ecab-select [options]="subjectOptions()"
                     [ngModel]="subject()"
                     [ngModelOptions]="{ standalone: true }"
                     [placeholder]="'message.context.selectSubject' | translate"
                     (selectionChange)="onSubjectChange($any($event))"></ecab-select>
      </div>
    </div>

    <footer class="transfer-footer">
      <ecab-button variant="secondary"
                   [label]="'message.context.cancel' | translate"
                   (clicked)="cancel()"></ecab-button>
      <ecab-button variant="primary"
                   [label]="'message.transferDialog.save' | translate"
                   [disabled]="!canSave()"
                   (clicked)="save()"></ecab-button>
    </footer>
  </section>
</div>
